;(function () {

var MiniCartQuantityView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.parent = opts.parent;

    // console.log('init mini cart quantity view');

    this.$input = this.$el.find('input');
    this.qty = this.$input.val();
    this.idx = this.$el.closest('.line-item').index();
    this.render();
  },
  render: function () {
    var $plus = $("<div class='plus'>");
    var $minus = $("<div class='minus'>");

    $plus.insertAfter(this.$input);
    $minus.insertBefore(this.$input);
  },
  minus: function () {
    if (this.qty > 0) {
      this.qty--;
      this.update();
    }
  },
  plus: function (e) {
    this.qty++;
    this.update();
  },
  update: function () {
    $.post('/cart/change.js', { quantity: this.qty, line: this.idx+1 }, _.bind(function (d) {

      this.parent._render(d);

    }, this), 'json');
  },
  events: {
    'click .plus': 'plus',
    'click .minus': 'minus',
    'blur input': function (e) {
      var qty = this.$input.val();

      if ( !_.isNaN(parseInt(this.qty)) ) {
        if (parseInt(qty) !== this.qty) {
          this.qty = qty;
          this.update();
        }
      }
    }
  }
});

module.exports = MiniCartQuantityView;

}());